/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'underscore'
],
(_) => {

	const ENCODED_NULL = '\u0000';

	return class QueryServiceUtils {

		static extractQueryResultDataValuesForProperty(queryResultData) {
			//For properties, many categories might have the same value.
			//(ie: a color property for a product might be 'red' for many products)
			//We only want to return 1 instance of any value.
			const resultRowSize = queryResultData.getRowCount();
			const uniqueResultMap = {};
			for (let rowIndex = 0; rowIndex < resultRowSize; rowIndex++) {
				let value = queryResultData.getValue(rowIndex, 0)[0];
				let nullKey = _.isNull(value.d) ? ENCODED_NULL : null;
				uniqueResultMap[nullKey || value.d || value] = value;
			}

			let values;
			//Move null value to the top
			let nullVal = uniqueResultMap[ENCODED_NULL];
			if (nullVal){
				delete uniqueResultMap[ENCODED_NULL];
				values = [nullVal].concat(_.values(uniqueResultMap));
			} else {
				values = _.values(uniqueResultMap);
			}
			return values;
		}

		static extractListOfQueryResultData(queryResultData) {

			const resultRowSize = queryResultData.getRowCount();
			const aResults = [];

			for (let rowIndex = 0; rowIndex < resultRowSize; rowIndex++) {
				const value = queryResultData.getValue(rowIndex, 0)[0];
				aResults.push(value);
			}

			return aResults;
		}

		/**
		 * Get prompt use values from an array of value object
		 * @param {object[]} objValueList an array of query result values object
		 * @returns {String[]} an array of string values
		 */
		static getPromptValues(objValueList, dataType) {
			if (!objValueList || !objValueList.length) {
				return objValueList;
			}
			const oldSpec = objValueList[0].u;
			let valueType;
			if (oldSpec) {
				valueType = dataType === 'memberUniqueName' || dataType === 'hierarchyUniqueName' ? 'u' : 'd';
			} else {
				valueType = dataType === 'memberUniqueName' || dataType === 'hierarchyUniqueName' ? 'value' : 'label';
			}
			return _.pluck(objValueList, valueType);
		}

		static COLUMN_QUERY_SIZE_LIMIT = 1000;

	};

});